import { Vue } from 'vue-property-decorator';
import fetch from '@/helpers/fetch';
import { cloneDeep } from 'lodash';

export default {
	state: {
		selectedTrialId: null,
		movementsPerTrial: {},
		movementsPerTrialInitial: {},
	},
	mutations: {
		SET_MOVEMENTS_PER_TRIAL(state, mov) {
			Vue.set(
				state.movementsPerTrial,
				mov.trialId,
				mov.list,
			);
		},
		SET_MOVEMENTS_PER_TRIAL_INITIAL(state, mov) {
			const list = cloneDeep(mov.list);

			Vue.set(
				state.movementsPerTrialInitial,
				mov.trialId,
				list,
			);
		},
		SET_SELECTED_TRIAL_ID(state, trialId) {
			state.selectedTrialId = trialId;
		},
	},
	actions: {
		fetchMovements: async function(context, trialId: number): Promise<object[]> {
			const data = await fetch.get('/api/movements/' + trialId);
			const list = data.map((mov) => {
				mov.date = mov.date.split('T')[0];
				return mov;
			});
			const result = {
				trialId,
				list,
			};

			context.commit(
				'SET_MOVEMENTS_PER_TRIAL_INITIAL',
				result,
			);

			context.commit(
				'SET_MOVEMENTS_PER_TRIAL',
				result,
			);

			return data;
		},
		selectMovements: function(context, trialId: number | string): void {
			context.commit('SET_SELECTED_TRIAL_ID', trialId);

			if (!context.state.movementsPerTrial[trialId]) {
				if (trialId === 'new') {
					context.commit(
						'SET_MOVEMENTS_PER_TRIAL',
						{
							trialId,
							list: [],
						},
					);
				} else {
					context.dispatch('fetchMovements', trialId);
				}
			}
		},
		resetMovements: function(context, trialId: number | string): void {
			context.commit(
				'SET_MOVEMENTS_PER_TRIAL',
				{
					trialId,
					list: null,
				},
			);
		},
		fetchDeleteMovement: async function(context, movId: number): Promise<object[]> {
			const data = await fetch.delete('/api/movements/' + movId, {});

			// const list = data.map((mov) => {
			// 	mov.date = mov.date.split('T')[0];
			// 	return mov;
			// });
			// const result = {
			// 	trialId,
			// 	list,
			// };

			// context.commit(
			// 	'SET_MOVEMENTS_PER_TRIAL_INITIAL',
			// 	result,
			// );

			// context.commit(
			// 	'SET_MOVEMENTS_PER_TRIAL',
			// 	result,
			// );

			return data;
		},
	},
};
